/** Titulo fixo da aba do acesso web da escola. */
export const TITULO_ABA = 'Momy | Escola';

export function tituloDaAba(): string {
  return TITULO_ABA;
}
